module.exports = {
	lightBlue: "#00ADB5",
	darkBlue: "#008E95",
	passive: "#999999",
	usualBackground: "rgba(186 222 224)",
	"linkedin-blue": "#0072b1",
	darkWhite: "#F5FBFC",
	black: "#001011",
	mainBlue: "#3878E8",
	primaryHover: "#699fff",
	whiteBlue: "#eaf0fd",
};
